import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommandService} from '@core/services/command.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'app-fillable-pdf-translation-command',
  templateUrl: './fillable-pdf-translation-command.component.html',
  styleUrls: ['./fillable-pdf-translation-command.component.scss']
})

export class FillablePdfTranslationCommandComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private driveId: any = '';
  private directoryEntryId: any = '';
  private viewMode: any = '';
  private isClientDrive = false;
  private dataItemId: any = '';
  private translatedFileContentId: any = '';

  constructor(private commandService: CommandService,
              public snackBarService: SnackBarService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      if (params) {
        if (params.driveId) {
          this.driveId = params.driveId;
        }
        if (params.itemId) {
          this.directoryEntryId = params.itemId;
        }
        if (params.viewMode) {
          this.viewMode = params.viewMode;
        }
        if (params.isClientDrive) {
          this.isClientDrive = params.isClientDrive.toLowerCase() === 'true';
        }
        if (params.translatedFileContentId) {
          this.translatedFileContentId = params.translatedFileContentId;
        }
      }
      });
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(queryParams => {
      if (queryParams) {
        if (queryParams.dataItemId ) {
          this.dataItemId = queryParams.dataItemId;
        }
      }
    });
    this.navigateToFillablePdfCommand();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private navigateToFillablePdfCommand() {
    console.log('navigating to fillable pdf');
    if (this.driveId && this.directoryEntryId && this.viewMode) {
      let command = new PlatformCommand('OpenFileCommand', 'FileStoreApi');
      command.fieldValues['DriveId'] = this.driveId;
      command.fieldValues['IsClientDrive'] = this.isClientDrive;
      command.fieldValues['ItemId'] = this.directoryEntryId;
      command.fieldValues['ViewMode'] = this.viewMode;
      command.fieldValues['DataItemId'] = this.dataItemId;
      command.fieldValues['TranslatedFileContentId'] = this.translatedFileContentId;
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if (response && response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        } else {
          this.snackBarService.showError('File loading failed!');
          this.router.navigateByUrl('drive');
        }
      }, err => {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showError('File loading failed!');
        this.router.navigateByUrl('drive');
      });
    }
  }
}
